import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { ShopItem } from '../shop-item.model';

@JsonObject('ShopItemsResultsResponse')
export class ShopItemsResultsResponse extends ApiResultsResponse<ShopItem> {

  @JsonProperty('results', [ShopItem])
  override results: ShopItem[] = [];
}
